/* Il Botteghino - consenso cookie (REQ-LEG-2): ponte verso Shopify.customerPrivacy, markup in bt-cookie.liquid.
   Senza risposta della API entro 3 secondi il banner resta e nulla parte.
   Conteggio delle scelte (22/10/2026): bt:consent:shown quando il primo livello del banner appare (una volta per pagina),
   bt:consent con choice (all/necessary/custom) e source (banner/settings) a ogni scelta esplicita. Li legge bt-track.liquid. */
(function () {
  "use strict";
  var KEY = "bt-consent", YEAR = 31536e6, WAIT = 3000, S = window.Shopify;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var ban = $("#cookie"), dlg = $("#preferenze-cookie"), live = $("[data-consent-live]");
  if (!ban || !dlg) return;
  /* Il banner è fisso a schermo: nel DOM lo si porta subito dopo «Vai al contenuto», così entra presto nell'ordine di tabulazione
     e di lettura (prima era in fondo alla pagina, dopo 90 elementi). Non è modale: il focus non viene preso né intrappolato. */
  var skip = $(".bt-skip");
  if (skip && skip.parentNode) skip.parentNode.insertBefore(ban, skip.nextSibling);
  var cp = null, opener = null, timer = 0, src = "banner", shownSent = false;

  function saved() { // scelta nel registro del browser, se recente
    try {
      var s = JSON.parse(localStorage.getItem(KEY));
      return s && s.d && Date.now() - Date.parse(s.d) < YEAR ? s : null;
    } catch (e) { return null; }
  }
  function ready(p) { return !!p && typeof p.currentVisitorConsent === "function" && typeof p.setTrackingConsent === "function"; }
  function current() { // scelta registrata da Shopify; null se la API non è ancora completa o lancia (visto in Safari)
    try { return ready(cp) ? cp.currentVisitorConsent() : null; } catch (e) { return null; }
  }
  function load(cb) {
    var tries = 0;
    var go = function () { // in WebKit customerPrivacy può esistere senza metodi: si riprova per un paio di secondi
      if (ready(S.customerPrivacy)) { cp = S.customerPrivacy; return cb(); }
      if (++tries < 20) setTimeout(go, 100);
    };
    if (S && S.customerPrivacy) return go();
    if (S && S.loadFeatures) S.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (e) { if (!e && S.customerPrivacy) go(); });
  }
  function show() { // primo livello visibile: segnale una volta sola per pagina
    ban.hidden = false;
    if (shownSent) return;
    shownSent = true;
    document.dispatchEvent(new CustomEvent("bt:consent:shown"));
  }
  function err(on) {
    [].forEach.call(document.querySelectorAll("[data-consent-error]"), function (p) { p.textContent = on ? p.getAttribute("data-msg") : ""; });
  }
  function setSw(b, on) {
    b.setAttribute("aria-checked", on ? "true" : "false");
    $(".bt-switch__text", b).textContent = b.getAttribute(on ? "data-on" : "data-off");
  }
  function sw(cat) { return $('[data-consent-cat="' + cat + '"]', dlg); }
  function on(cat) { return sw(cat).getAttribute("aria-checked") === "true"; }

  function apply(a, m, done, fail) {
    var ok = false;
    err(false);
    clearTimeout(timer);
    timer = setTimeout(function () { if (!ok) { err(true); if (fail) fail(); } }, WAIT);
    load(function () {
      cp.setTrackingConsent({ analytics: a, marketing: m, preferences: a || m, sale_of_data: m }, function () { ok = true; clearTimeout(timer); done(); });
    });
  }
  function choose(a, m, kind) {
    apply(a, m, function () {
      try { localStorage.setItem(KEY, JSON.stringify({ d: new Date().toISOString(), a: a, m: m })); } catch (e) { /* storage non disponibile */ }
      ban.hidden = true;
      if (dlg.open) dlg.close();
      live.textContent = live.getAttribute("data-msg");
      setTimeout(function () { live.textContent = ""; }, 4000);
      document.dispatchEvent(new CustomEvent("bt:consent", { detail: { analytics: a, marketing: m, choice: kind, source: src } }));
    });
  }
  function openPrefs(from) {
    src = from;
    var s = saved(), c = current();
    setSw(sw("analytics"), c && c.analytics ? c.analytics === "yes" : !!(s && s.a));
    setSw(sw("marketing"), c && c.marketing ? c.marketing === "yes" : !!(s && s.m));
    err(false);
    opener = document.activeElement;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute("open", "");
    $(".bt-switch", dlg).focus();
  }

  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-consent]"), t = e.target.closest("[data-consent-cat]");
    if (t) return setSw(t, t.getAttribute("aria-checked") !== "true");
    if (e.target === dlg) return dlg.close();
    var k = b && b.getAttribute("data-consent");
    if (k && !dlg.open && !b.closest("#preferenze-cookie")) src = "banner"; // scelta dal primo livello
    if (k === "accetta") choose(true, true, "all");
    else if (k === "rifiuta") choose(false, false, "necessary");
    else if (k === "salva") choose(on("analytics"), on("marketing"), "custom");
    else if (k === "personalizza") openPrefs("banner");
    else if (k === "apri") openPrefs("settings");
    else if (k === "chiudi") dlg.close();
  });
  dlg.addEventListener("close", function () {
    if (opener && opener.isConnected && !opener.closest("[hidden]")) opener.focus();
  });

  /* avvio: il banner resta se Shopify non conferma una scelta */
  timer = setTimeout(show, WAIT);
  load(function () {
    clearTimeout(timer);
    var c = current(), s = saved();
    if (c && (c.analytics || c.marketing)) ban.hidden = true;
    else if (s) apply(!!s.a, !!s.m, function () { ban.hidden = true; }, show);
    else show();
  });
})();
